const TOUCH_EVENTS = ['touchstart', 'touchmove', 'touchend'];
const OVERLAY_MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'keydown'];
const TOP_LEVEL_ZOOM_CLICK_MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'keydown', 'mouseout'];

/**
 *
 * @param {Touch} vertexA
 * @param {MouseEvent|Touch} vertexB
 * @returns {number}
 */
export function clientHypotenuse(vertexA, vertexB) {
  // pythagorean theorem
  return Math.sqrt(Math.abs(vertexA.clientY - vertexB.clientY) ** 2 + Math.abs(vertexA.clientX - vertexB.clientX) ** 2);
}

/**
 *
 * @param {TouchEvent} touchEvent
 * @returns {number}
 */
export function getFingerDistance(touchEvent) {
  return clientHypotenuse(touchEvent.touches[0], touchEvent.touches[1]);
}

export function updateEvent(event, newData) {
  Object.assign(event, newData);

  return event;
}
/**
 *
 * @param {TouchEvent} touchEvent
 * @returns {{clientY: number | undefined, clientX: number | undefined}}
 */
export function getClientFromFirstTouch(touchEvent) {
  return {
    clientX: touchEvent.changedTouches[0]?.clientX,
    clientY: touchEvent.changedTouches[0]?.clientY,
  };
}

/**
 *
 * @param {TouchEvent} touchEvent
 * @returns {{clientX: number | undefined, clientY: number | undefined}}
 */
export function getAverageTouchClient(touchEvent) {
  const count = touchEvent.changedTouches?.length;
  let x = 0;
  let y = 0;

  [...Array(count).keys()].forEach((i) => {
    const data = touchEvent.changedTouches[i];

    x += data?.clientX;
    y += data?.clientY;
  });

  return {
    clientX: x / count || 0,
    clientY: y / count || 0,
  };
}

/**
 *
 * @param {TouchEvent | MouseEvent | KeyboardEvent} event
 * @param {(event: KeyboardEvent | MouseEvent | TouchEvent) =>  void} callback
 */
export function invokeCallback(event, callback) {
  if (typeof callback === 'function') {
    callback(event);
  }
}

/**
 *
 * @param {import('vue').Ref<HTMLElement>} element
 * @param {[(i: number) => {}]} callbacks
 * @param {boolean} isTouchDevice
 * @param {boolean} isTopLevelZoomerClick
 * @param {boolean | AddEventListenerOptions} [options={}]
 */
export function addEventListenerChunk(element, callbacks, isTouchDevice, isTopLevelZoomerClick, options) {
  let MOUSE_EVENTS;
  if (isTopLevelZoomerClick) {
    MOUSE_EVENTS = TOP_LEVEL_ZOOM_CLICK_MOUSE_EVENTS;
  } else {
    MOUSE_EVENTS = OVERLAY_MOUSE_EVENTS;
  }

  const eventNames = isTouchDevice ? TOUCH_EVENTS : MOUSE_EVENTS;

  eventNames.forEach((eventName, i) => {
    element.value?.addEventListener(eventName, callbacks[i], options);
  });
}

export const checkForTouchDevice = () => 'ontouchstart' in document.documentElement;
